<div
  class="input-file-container"
  [attr.data-size]="size"
  [attr.data-disabled]="disabled"
  [attr.data-error]="error"
  [attr.data-has-file]="hasFile"
>
  <label *ngIf="label" class="input-file-label" [for]="inputId">
    {{ label }}
    <span *ngIf="required" class="required-indicator">*</span>
  </label>

  <div class="input-file-wrapper">
    <!-- Hidden file input -->
    <input
      #fileInput
      [id]="inputId"
      type="file"
      class="input-file-hidden"
      [accept]="accept"
      [multiple]="multiple"
      [disabled]="disabled"
      [required]="required"
      [attr.aria-label]="label"
      [attr.aria-required]="required"
      [attr.aria-invalid]="error"
      (change)="onFileChange($event)"
      (focus)="onFileFocus()"
      (blur)="onFileBlur()"
    />

    <!-- Custom file input display -->
    <div class="input-file-display">
      <!-- Choose File button -->
      <span class="input-file-button">
        {{ buttonText }}
      </span>

      <!-- File name or placeholder -->
      <span class="input-file-text" [class.has-file]="hasFile">
        {{ displayText }}
      </span>
    </div>
  </div>

  <p *ngIf="helperText && !error" class="helper-text">
    {{ helperText }}
  </p>

  <p *ngIf="error && errorMessage" class="error-message">
    {{ errorMessage }}
  </p>
</div>
